export const FISHING_AND_HUNTING_SECTOR = '11';
export const MINING_QUARRYING_OIL_AND_GAS_SECTOR = '21';
export const UTILITIES_SECTOR = '22';
export const CONSTRUCTION_SECTOR = '23';
export const MANUFACTURING_SECTOR = '31';
export const WHOLESALE_TRADE_SECTOR = '42';
export const RETAIL_TRADE_SECTOR = '45';
export const TRANSPORTATION_AND_WAREHOUSING_SECTOR = '48';
export const INFORMATION_SECTOR = '51';
export const FINANCE_AND_INSURANCE_SECTOR = '52';
export const REAL_ESTATE_SECTOR = '53';
export const SCIENTIFIC_SERVICES_SECTOR = '54';
export const MANAGEMENT_OF_COMPANIES_SECTOR = '55';
export const ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR = '56';
export const EDUCATIONAL_SERVICES_SECTOR = '61';
export const HEALTH_CARE_SECTOR = '62';
export const ARTS_ENTERTAINMENT_SECTOR = '71';
export const ACCOMMODATION_SERVICES_SECTOR = '72';
export const OTHER_SERVICES_SECTOR = '81';
export const PUBLIC_ADMINISTRATION_SECTOR = '92';

export const SECTOR_OPTIONS = [
  { value: FISHING_AND_HUNTING_SECTOR, label: 'Agriculture, Forestry, Fishing and Hunting' },
  { value: MINING_QUARRYING_OIL_AND_GAS_SECTOR, label: 'Mining, Quarrying, and Oil and Gas Extraction' },
  { value: UTILITIES_SECTOR, label: 'Utilities' },
  { value: CONSTRUCTION_SECTOR, label: 'Construction' },
  { value: MANUFACTURING_SECTOR, label: 'Manufacturing' },
  { value: WHOLESALE_TRADE_SECTOR, label: 'Wholesale Trade' },
  { value: RETAIL_TRADE_SECTOR, label: 'Retail Trade' },
  { value: TRANSPORTATION_AND_WAREHOUSING_SECTOR, label: 'Transportation and Warehousing' },
  { value: INFORMATION_SECTOR, label: 'Information' },
  { value: FINANCE_AND_INSURANCE_SECTOR, label: 'Finance and Insurance' },
  { value: REAL_ESTATE_SECTOR, label: 'Real Estate and Rental and Leasing' },
  { value: SCIENTIFIC_SERVICES_SECTOR, label: 'Professional, Scientific, and Technical Services' },
  { value: MANAGEMENT_OF_COMPANIES_SECTOR, label: 'Management of Companies and Enterprises' },
  {
    value: ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
    label: 'Administrative and Support and Waste Management and Remediation Services',
  },
  { value: EDUCATIONAL_SERVICES_SECTOR, label: 'Educational Services' },
  { value: HEALTH_CARE_SECTOR, label: 'Health Care and Social Assistance' },
  { value: ARTS_ENTERTAINMENT_SECTOR, label: 'Arts, Entertainment, and Recreation' },
  { value: ACCOMMODATION_SERVICES_SECTOR, label: 'Accommodation and Food Services' },
  { value: OTHER_SERVICES_SECTOR, label: 'Other Services (except Public Administration)' },
  { value: PUBLIC_ADMINISTRATION_SECTOR, label: 'Public Administration' },
];